import { render, staticRenderFns } from "./OrderExaminationTab.vue?vue&type=template&id=44cdc217&scoped=true"
import script from "./OrderExaminationTab.vue?vue&type=script&lang=js"
export * from "./OrderExaminationTab.vue?vue&type=script&lang=js"
import style0 from "./OrderExaminationTab.vue?vue&type=style&index=0&id=44cdc217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cdc217",
  null
  
)

export default component.exports